import {
  createQuickListService,
  getProductsByQuickListIdService,
  getQuickListsWithoutDetailService,
} from 'redux/services/quickListsServices'

export const createQuickListAction = payload => async () => {
  const response = await createQuickListService(payload)
  const { data, status } = response
  if (status !== 200 || !data?.Data) {
    throw new Error('createQuickListAction: respuesta inválida del servidor')
  }
  return response
}

export const getQuickListsWithoutDetailAction = payload => async () => {
  const response = await getQuickListsWithoutDetailService(payload)
  const { data, status } = response
  if (status !== 200 || !data?.Data) {
    throw new Error(
      'getQuickListsWithoutDetailAction: respuesta inválida del servidor'
    )
  }
  return response
}

export const getProductsByQuickListIdAction = payload => async () => {
  const response = await getProductsByQuickListIdService(payload)
  const { data, status } = response
  if (status !== 200 || !data?.Data) {
    throw new Error(
      'getProductsByQuickListIdAction: respuesta inválida del servidor'
    )
  }
  return response
}
